import {
  IEngagement,
  IEngagementAddRequirementRequest
} from "@wingspanhq/payments/dist/interfaces";
import { WSMutationConfig } from "@ws-react-query";
import { useWSMutation } from "../../helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import {
  QUERY_ENGAGEMENT,
  QUERY_ENGAGEMENT_LIST,
  QUERY_ENGAGEMENT_LIST_SIZE
} from "../keys";
import { addRequirementToEngagement } from "../../../services/engagements";
import {
  QUERY_REQUIREMENT_DEFINITIONS_LIST_All,
  QUERY_REQUIREMENT_DEFINITIONS_LIST_SIZE
} from "../../requirementDefinitions/keys";
import { QUERY_EXTENDED_REQUIREMENT_DEFINITIONS } from "../../requirementDefinitions/query/useExtendedRequirementDefinitions";
import { QUERY_LIST_RESOURCE_EVENTS } from "../../resourceEvents/queries/useQueryListEvents";

export const useAddRequirementToEngagement = (
  id: string,
  config?: WSMutationConfig<IEngagement, WSServiceError>
) =>
  useWSMutation(
    (request: IEngagementAddRequirementRequest) =>
      addRequirementToEngagement(id, request),
    {
      ...config,
      dependencies: [
        QUERY_ENGAGEMENT_LIST,
        QUERY_ENGAGEMENT_LIST_SIZE,
        QUERY_REQUIREMENT_DEFINITIONS_LIST_All,
        QUERY_REQUIREMENT_DEFINITIONS_LIST_SIZE,
        QUERY_EXTENDED_REQUIREMENT_DEFINITIONS,
        QUERY_LIST_RESOURCE_EVENTS
      ],
      awaitDependencies: [[QUERY_ENGAGEMENT, id]]
    }
  );
